import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['firstName', 'zipCode', 'taxIdInput']

  toggleTaxIdField (event) {
    const taxField = this.taxIdInputTarget.closest('.tax-field')
    const companyName = event.target.value.trim()

    if (companyName.length > 0) {
      taxField.classList.add('d-flex')
      taxField.classList.remove('d-none')
      this.taxIdInputTarget.required = true
    } else {
      taxField.classList.add('d-none')
      taxField.classList.remove('d-flex')
      this.taxIdInputTarget.required = false
      this.taxIdInputTarget.value = ''
    }
  }

  submit () {
    const itemsAttributes = JSON.parse(this.data.get('datalayer-ecommerce-items'))

    dataLayer.push({
      event: 'ce_checkout',
      ecommerce: {
        checkout: {
          actionField: { step: 1, option: 'Stripe' },
          products: itemsAttributes
        }
      }
    })

    const variables = JSON.parse(this.data.get('datalayer-buyer-to-payment-click'))
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
      ...variables,
      firstName: this.firstNameTarget.value,
      zipCode: this.zipCodeTarget.value,
      event: 'buyer-to-payment-click',
      ecommerce: {
        value: variables.value,
        currency: 'EUR'
      }
    })
  }
}
